export class NoticiaModel {
    public idNoticia: number;
    public titulo: string;
    public resumen: string;
    public cuerpo: string;
    public imagen: string;
    public video: string;
    public archivo: string;
    public fechaRegistro: string;
    public idTipo: number;
    
    constructor() { }
}